module.exports = __webpack_public_path__ + "static/media/hossam.f66addea.png";